<template>
  <div>
    <vs-tabs v-model="tabIndex">
      <vs-tab v-for="tab of tabList" :key="tab.name" :label="tab.label" @click="onClickTab(tab)" />
    </vs-tabs>

    <!-- search -->
    <search-nav @handleSearch="onClickSearch">
      <div class="search-layout w-full grid col-gap-4 flex-wrap xl:flex">
        <component
          v-for="(component, index) in stdSearchComponents"
          :key="index"
          v-if="showSearchNavItem(component['options'])"
          :is="component['component']"
          :label="component['label']"
          :query="component['query']"
          :options="component['options']"
          :onClickSearch="onClickSearch"
          v-model="nav.value[component['value']]"
        />
      </div>
    </search-nav>

    <!-- list -->
    <div>
      <fragment>
        <div class="w-full flex">
          <div class="flex mr-auto mb-4">
            <vs-select v-model="perPage" autocomplete class="mr-4" style="width: 110px">
              <vs-select-item v-for="v in [10, 20, 30, 50]" :key="v" :text="`${v}개씩 보기`" :value="v" />
            </vs-select>
          </div>
        </div>
      </fragment>
      <div class="w-full overflow-x-auto">
        <div class="list">
          <div class="list-header list-grid">
            <div>No.</div>
            <div>{{ $t('현장명') }}</div>
            <div>{{ $t('업체명') }}</div>
            <div>{{ $t('아이디') }}</div>
            <div>{{ $t('내국인/외국인') }}</div>
            <div>{{ $t('이름') }}</div>
            <div>{{ $t('직종') }}</div>
            <div>{{ $t('휴대폰번호') }}</div>
            <div>{{ $t('이메일') }}</div>
          </div>
          <div class="list-body">
            <div v-for="(data, index) in paginationList" :key="index" class="list-grid cursor-pointer" @click="onClickItem(data)">
              <template>
                <div>{{ index + 1 }}</div>
                <div>{{ data.field_name || "-" }}</div>
                <div>{{ data.company ? data.company.com_name : "-" }}</div>
                <div>{{ data.username || "-" }}</div>
                <div>{{ data.foreign || "-" }}</div>
                <div>{{ data.name || "-" }}</div>
                <div>{{ data.position || "-" }}</div>
                <div style="white-space: nowrap;">{{ formatPhone(data.phone) || "-" }}</div>
                <div>{{ data.email || "-" }}</div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <div class="vs-con-table">
        <div class="con-pagination-table vs-table--pagination">
          <k-pagination :total="lastPage ? lastPage : 0" v-model="page"></k-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchNav from "@/components/nav/SearchNav.vue";
import SearchColumnKeyword from "@/views/list/components/SearchColumnKeyword.vue";
import FieldSelector from "@/components/selector/FieldSelector.vue";
import List from "@/views/boards/single-page/984/List.js";
import searchComponent from "@/views/list/components/include";
import KPagination from "@/components/kPagination/kPagination.vue";

export default {
  components: {
    KPagination,
    FieldSelector,
    SearchColumnKeyword,
    SearchNav,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    header: Object,
    value: Object,
    mode: {
      type: String,
      default: "list",
    },
  },
  computed: {
    tabList() {
      const list = [{ code: 0, name: "page-regist-account-list", label: "회원관리" }];
      return list;
    },
    projectId() {
      return this.$route.params.proj_id;
    },

    stdSearchComponents() {
      const getComponents = List.components;
      if (getComponents) {
        // 중복제거 코드 : filter((value, index, self) => self.indexOf(value) === index)
        const stdSearchComponents = getComponents();
        if (stdSearchComponents && stdSearchComponents.length > 0) {
          for (const component of stdSearchComponents) {
            component.component = searchComponent[component["component"]];
          }
        }
        return stdSearchComponents;
      }
      return [];
    },
    paginationList() {
      return this.allList;
    },
    // 검색된 목록
    searchedList() {
      return this.allList;
    },
  },
  watch: {
    perPage() {
      this.page = 1;
      this.loadListBoardAll();
      this.updateQueryParams();
    },
    page() {
      this.loadListBoardAll();
      this.updateQueryParams();
    },
    '$route.query': {
      handler(newQuery) {
        this.loadStateFromQuery(newQuery);
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      tabIndex: 0,
      nav: {
        value: {},
      },
      page: 1,
      lastPage: 1,
      perPage: 10,
      total: 0,
      allList: [],
    };
  },
  created() {
    this.initBreadcrumb();
    this.loadStateFromQuery(this.$route.query);
    this.loadListBoardAll();
  },
  methods: {
    updateQueryParams() {
      const query = { ...this.$route.query };

      // 페이지 번호 설정
      query.page = this.page.toString();
      query.perPage = this.perPage.toString();

      // 검색 조건 설정
      if (this.nav.value && this.nav.value.column) {
        if (this.nav.value.column.head) {
          query.ck_t = this.nav.value.column.head;
        } else {
          delete query.ck_t;
        }

        if (this.nav.value.column.keyword) {
          query.ck_k = this.nav.value.column.keyword;
        } else {
          delete query.ck_k;
        }
      } else {
        delete query.ck_t;
        delete query.ck_k;
      }

      // 현재 URL과 다른 경우에만 라우터 변경
      const currentQuery = JSON.stringify(this.$route.query);
      const newQuery = JSON.stringify(query);

      if (currentQuery !== newQuery) {
        this.$router.replace({ query }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      }
    },

    loadStateFromQuery(query) {
      if (!query) return;

      // 페이지 번호와 페이지당 항목 수 복원
      if (query.page) {
        this.page = parseInt(query.page) || 1;
      }

      if (query.perPage) {
        this.perPage = parseInt(query.perPage) || 10;
      }

      // 검색 조건 복원
      if (query.ck_t || query.ck_k) {
        if (!this.nav.value.column) {
          this.nav.value.column = {};
        }

        if (query.ck_t) {
          this.nav.value.column.head = query.ck_t;
        }

        if (query.ck_k) {
          this.nav.value.column.keyword = query.ck_k;
        }
      }
    },

    initBreadcrumb() {
      this.$store.commit("menu/UPDATE_PAGE_LIST", [{ title: "Home" }, { title: "작업자 관리" }, { title: "회원관리", active: true }]);
    },
    onClickTab(tab) {
      this.tabIndex = tab.code;
      this.clearStateFromLocalStorage();
      this.$router.push({ name: tab.name });
    },
    showSearchNavItem(options) {
      if (options && options.visibleKeyValue) {
        for (const keyValue of options.visibleKeyValue) {
          const key = Object.keys(keyValue)[0];
          const value = keyValue[key];
          const navValue = this.findJsonDataWithDottedPath(this.nav.value, key);
          if (navValue !== value) {
            if (Array.isArray(navValue) && navValue.toString() === value) {
              return true;
            }
          } else {
            return true;
          }
        }
        return false;
      }
      return true;
    },
    async loadListBoardAll() {
      const conditions = List.getConditions(this.nav);
      const params = {
        page: this.page,
        perPage: this.perPage,
        projectId: this.projectId,
      };

      if (conditions.length > 0) {
        params.searchType = "and";
      }

      conditions.forEach((condition) => {
        if (condition.value !== "") {
          params[condition.key] = condition.value;
        }
      });
      try {
        const response = await this.$store.dispatch("member/LOAD_MEMBERS", params);
        if (response && response.data) {
          this.allList = response.data.map((data) => {
            const metas = data.metas;
            const metaKeys = {
              field_name: "업체.fields[0].field_name",
              foreign: "is_foreigner",
            };

            const metaValues = Object.keys(metaKeys).reduce((acc, key) => {
              const meta = metas.find((meta) => meta.meta_key === metaKeys[key]);
              acc[key] = meta ? meta.meta_value : "";
              return acc;
            }, {});

            const field_name = metaValues.field_name;
            const foreignValue = !!metaValues.foreign && metaValues.foreign === "1" ? "외국인" : "내국인";

            return {
              id: data.id,
              field_name,
              company: data.company, // 업체
              username: data.username, // user id
              name: data.name, // 이름
              position: data.position, // 직종
              phone: data.phone, // 전화번호
              email: data.email, // 이메일
              foreign: foreignValue, // 외국인내국인
            };
          });
          this.lastPage = response.last_page;
        } else {
          console.error("Response or response.data is undefined");
        }
      } catch (err) {
        console.error("Error fetching data", err);
      }
    },

    onClickSearch() {
      this.page = 1;
      this.loadListBoardAll();
      this.updateQueryParams();
    },

    onClickItem(data) {
      this.$router.push({
        name: "page-regist-account-detail",
        params: { proj_id: this.projectId, id: data.id },
        query: this.$route.query // 현재 쿼리 파라미터 유지
      });
    },

    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    },

    formatPhone(phone) {
      if (!phone) return "";

      // 하이픈 제거
      const cleanNum = phone.replace(/-/g, "");

      // 전화번호 길이에 따라 형식 적용
      if (cleanNum.length === 10) {
        // 10자리: 일반 전화번호 (02-XXXX-XXXX) 또는 휴대폰 (010-XXX-XXXX)
        if (cleanNum.startsWith("02")) {
          return cleanNum.replace(/(\d{2})(\d{4})(\d{4})/, "$1-$2-$3");
        } else {
          return cleanNum.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
        }
      } else if (cleanNum.length === 11) {
        // 11자리: 휴대폰 (010-XXXX-XXXX)
        return cleanNum.replace(/(\d{3})(\d{4})(\d{4})/, "$1-$2-$3");
      } else if (cleanNum.length === 12) {
        // 12자리: 특수 번호
        return cleanNum.replace(/(\d{4})(\d{4})(\d{4})/, "$1-$2-$3");
      } else {
        // 다른 길이는 그대로 반환
        return cleanNum;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.list {
  text-align: center;

  .list-header {
    font-weight: 700;
    & > div {
      background-color: #f5f5f5;
      border-top: 1px solid #e0e0e0;
      border-bottom: 1px solid #e0e0e0;
    }
  }
  .list-body {
    & > div > div {
      background-color: #ffffff;
      border-bottom: 1px solid #e0e0e0;
    }
    & > div:hover {
      background-color: #f5f5f5;
      color: #000;
      font-weight: bold;
    }
    & > div.active {
      background-color: #7e72f299;
      color: #fff;
    }
  }

  .list-grid {
    display: grid;
    grid-template-columns: 60px repeat(8, minmax(100px, 1fr));

    & > div {
      padding: 10px 4px;
      justify-content: center;
      align-content: center;
    }
  }
  .list-edit {
    display: none;
  }

  button {
    width: 32px;
    height: 32px;

    display: flex;
    align-items: center;
    justify-content: center;

    color: #7e72f2;
    background: none;
    border: 1px solid #7e72f2;
    border-radius: 4px;
    cursor: pointer;

    span {
      margin: 0;
    }
  }
}
</style>
